import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, Col, FormGroup, Input, Label, Modal, Row} from "reactstrap";
import scanningBarcodeGif from '../../assets/img/logo/scanning_barcode.gif';
import modelImageDefault from '../../assets/img/banner/rack.png';
import HorizontalLine from "../Widget/HorizontalLine";
import * as PropTypes from 'prop-types';
import Global from "../../utils/Global";
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import {isEmpty} from "../../utils/Utilities";
import MyCardImage from "../Card/MyCardImage";
import Image from "../Widget/Image";
import PrimaryCardHeader from "../Widget/PrimaryCardHeader";
import {cleanNonNumeric} from "enqc-utilities/src/utils/Utilities";

// const serialNumberOrReferenceRef = useRef(null)

/*= (message, okCallback, cancelCallback) =>*/
export default class FindInspectionModal extends BaseComponent{


    props  = {}

    constructor(props){
        super(props);
        this.state = {
            serialNumberOrReference:"",
            model:this.props.model?this.props.model:{},
            viewFocus:"serialNumberOrReference",
            serverMessage:undefined,
        }
    }

    componentDidCatch(error, errorInfo) {
        // this.serialNumberOrReferenceRef.current.focus()
    }

    componentWillReceiveProps(props, nextContext) {
        if(this.props!==props){
            this.setState({
                model:props.model?props.model:{},
                serialNumberOrReference:"",
                serverMessage:undefined,
            })
        }
    }

    findInspection=(searchMode, serialNumberOrReference)=>{
        let {model} = this.state
        if(searchMode && isEmpty(serialNumberOrReference)){
            return;
        }
        let {onScanEntry} = this.props
        if(!onScanEntry){
            onScanEntry = () => {}
        }
        this.get(Global.API.FIND_INSPECTION, {
            params:{keyword:serialNumberOrReference, modelId:model.id}
        }, null, response=>{
            if(response.code===200){
                let assembly = response.data
                if(searchMode){
                    onScanEntry(assembly)
                }
            }else{
                this.setState({
                    serverMessage:response.messageError,
                })
            }
        }, true, false)
    }


    render(){
        let {serialNumberOrReference, model, viewFocus, serverMessage} = this.state
        let modelCategory = model.modelCategory?model.modelCategory:{}
        return (
            /*xl-lg-sm*/
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    style={{minWidth:'80%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <PrimaryCardHeader content={(
                            <h3>{label.ScanTheReference}</h3>
                        )}/>
                        <CardBody>
                            <Row>
                                <Col md={4}>
                                    <Card>
                                        <CardBody>
                                            <MyCardImage
                                                style={{width:'260px'}}
                                                src={model.iconPhoto?model.iconPhotoUrl:modelImageDefault}
                                                onError={(elm)=>this.defaultImage(elm, modelImageDefault)}
                                            />
                                            <HorizontalLine/>
                                            <FormGroup style={{textAlign:'left'}}>
                                                <Label>{label.SystemType}</Label>
                                                <Input disabled value={model.systemType}/>
                                            </FormGroup>
                                            <FormGroup style={{textAlign:'left'}}>
                                                <Label>{label.Category}</Label>
                                                <Input disabled value={modelCategory.name}/>
                                            </FormGroup>
                                            <FormGroup style={{textAlign:'left'}}>
                                                <Label>{label.Description}</Label>
                                                <Input type="textarea" rows={4} disabled value={model.description}/>
                                            </FormGroup>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={8}>
                                    <Row>
                                        <Col>
                                            <Image style={{width:'400px'}} src={scanningBarcodeGif}/>
                                            <br/>
                                            <Label style={{fontSize:'1.1rem'}}>{label.OrEnterItManually}</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input
                                                autoFocus={viewFocus==="serialNumberOrReference"}
                                                name="serialNumberOrReference"
                                                size={28}
                                                bsSize={28}
                                                style={{fontSize:'2.2rem', textAlign:'center'}}
                                                type="text"
                                                value={serialNumberOrReference}
                                                onChange={(e) =>{
                                                    let value = e.target.value?e.target.value:""
                                                    value = cleanNonNumeric(value)
                                                    serialNumberOrReference = value
                                                    serialNumberOrReference = serialNumberOrReference.replace(/\s/g, '')
                                                    this.setState({
                                                        serialNumberOrReference:serialNumberOrReference
                                                    })
                                                }}
                                                onKeyDown={(e)=>{
                                                    if(e.key==="Tab"){
                                                        e.preventDefault()
                                                        this.setState({
                                                            viewFocus:"ok"
                                                        })
                                                    }
                                                    if(e.key==='Enter'){
                                                        e.preventDefault()
                                                        this.findInspection(true, serialNumberOrReference)
                                                    }
                                                }}
                                                placeholder={label.SerialCodeOrReferenceCode}
                                            />
                                        </Col>
                                    </Row>
                                    {serverMessage&&(
                                        <React.Fragment>
                                            <br/>
                                            <Row>
                                                <Col>
                                                    <span className="text-danger h5 font-weight-bolder">{serverMessage}</span>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    )}
                                    <br/>
                                    <Row>
                                        <Col style={{textAlign:'left'}}>
                                            <Button
                                                color={"danger"}
                                                onClick={() => this.props.onClickCancel()}>
                                                {label.Close}
                                            </Button>
                                        </Col>
                                        <Col style={{textAlign:'right'}}>
                                            {/*<Button*/}
                                            {/*    autoFocus={viewFocus==="ok"}*/}
                                            {/*    name={"ok"}*/}
                                            {/*    color={"primary"}*/}
                                            {/*    onClick={()=>{*/}
                                            {/*        this.findInspection(false,"")*/}
                                            {/*    }}>*/}
                                            {/*    {label.NewAssembly}*/}
                                            {/*</Button>*/}
                                            {/*&nbsp;*/}
                                            <Button onClick={(e) => {
                                                e.preventDefault()
                                                this.findInspection(true, serialNumberOrReference)
                                            }}>{label.SearchAssembly}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

FindInspectionModal.propTypes = {
    show:PropTypes.bool.isRequired,
    model:PropTypes.object.isRequired,
    onScanEntry:PropTypes.func.isRequired,
    onClickCancel:PropTypes.func.isRequired
}
